import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = [
    "overnightCheckbox",
    "daytimePricePackageSelect",
    "overnightPricePackageSelect",
    "possessNonExclusiveCheckbox"
  ]


  applyDropInAndPreBooking() {
    console.debug("[SpotOvernightProperties] applyDropInAndPreBooking")

    this.overnightCheckboxTarget.checked = true
    this.overnightCheckboxTarget.disabled = true
    this.overnightPricePackageSelectTarget.required = true
    this.overnightCheckboxTarget.dispatchEvent(new Event('change')) // trigger the togglein response to the checkbox being checked
  }

  applyDropInOnly() {
    console.debug("[SpotOvernightProperties] applyDropInOnly")

    this.overnightCheckboxTarget.disabled = false
  }

  resetOvernightFields(event) {
    console.debug("[SpotOvernightProperties] resetOvernightFields")

    this.overnightPricePackageSelectTarget.value = ""
    this.overnightPricePackageSelectTarget.required = event.currentTarget.checked
    this.possessNonExclusiveCheckboxTarget.checked = false
  }

  resetDaytimeFields(event) {
    console.debug("[SpotOvernightProperties] resetDaytimeFields")

    this.daytimePricePackageSelectTarget.value = ""
    this.daytimePricePackageSelectTarget.required = event.currentTarget.checked
  }
}
